/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { Button, ButtonToolbar } from "react-bootstrap";

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { openReceiptDialog, openDeleteDialog }
) => {
  const { deleted_at } = row;
  return (
    <>
      <ButtonToolbar className="view-download-btn justify-content-end">
        <Button
          disabled={deleted_at}
          variant="btn btn-icon btn-light-danger btn-sm mx-1 font-size-sm"
          onClick={() => {
            openDeleteDialog(row);
          }}
        >
          <i className="fas fa-trash-alt"></i>
        </Button>
      </ButtonToolbar>
      <> </>
    </>
  );
};
